import { Component, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ProductSelectComponent } from './product-select.component';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import { ContractService } from '../../contract.service';
import { ProductService } from '../../../product/product.service';

@Component({
  selector: 'vex-product-select-modal',
  templateUrl: './product-select-modal.component.html',
  styleUrls: ['./product-select.component.scss'],
})
export class ProductSelectModalComponent {
  @ViewChild(ProductSelectComponent) table: ProductSelectComponent;
  isProcessing = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProductSelectModalComponent>,
    private productService: ProductService,
    private snackbarService: SnackbarService,
    private contractService: ContractService,
    private cdr: ChangeDetectorRef,
  ) {}

  validate() {
    if (this.isProcessing || !this.data.contractId) {
      this.dialogRef.close(this.table.selectedProducts);
      return;
    }

    console.log('Starting validation, isProcessing:', this.isProcessing);
    this.isProcessing = true;
    this.cdr.detectChanges(); // Force la détection du changement
    console.log('isProcessing set to true, change detected');

    const productIds = this.table.selectedProducts.map(p => p._id);
    const startTime = Date.now();

    this.productService.addInternalProducts(productIds, this.data.contractId).subscribe({
      next: response => {
        const elapsedTime = Date.now() - startTime;
        console.log('API response received after', elapsedTime, 'ms');

        // Délai minimum de 800ms pour que l'utilisateur voie le spinner
        const minDelay = 800;
        const remainingDelay = Math.max(0, minDelay - elapsedTime);

        setTimeout(() => {
          this.isProcessing = false;
          this.cdr.detectChanges(); // Force la détection du changement
          console.log('isProcessing set to false, change detected');
          const success = response?.data;
          this.snackbarService[success ? 'success' : 'warning'](
            success ? 'Les produits ont été ajoutés avec succès' : "Aucun produit n'a été ajouté",
          );
          this.contractService.setIsValid(true);
          this.dialogRef.close({ success: true, needsRefresh: true });
        }, remainingDelay);
      },
      error: err => {
        console.log('API error:', err);
        this.isProcessing = false;
        this.cdr.detectChanges(); // Force la détection du changement
        this.snackbarService.danger(err.error?.message || "Une erreur est survenue lors de l'ajout des produits");
        this.dialogRef.close({ success: false });
      },
    });
  }

  closeDialog() {
    if (this.isProcessing) {
      return;
    }
    this.dialogRef.close(null);
  }
}
